// import React, { useState } from 'react';

// const DATA_TYPES = [
//     { type: 'INT', needsLength: false },
//     { type: 'VARCHAR', needsLength: true },
//     { type: 'CHAR', needsLength: true },
//     { type: 'TEXT', needsLength: false },
//     { type: 'DATE', needsLength: false },
//     { type: 'DATETIME', needsLength: false },
//     { type: 'FLOAT', needsLength: false },
//     { type: 'DOUBLE', needsLength: false },
//     { type: 'BOOLEAN', needsLength: false }
// ];

// const TableCreate = () => {
//     const [tableName, setTableName] = useState('');
//     const [rawTableName, setRawTableName] = useState('');
//     const [columns, setColumns] = useState([
//         { name: '', type: '', length: '', description: '', isPrimaryKey: false, isAutoIncrement: false, isNullable: true }
//     ]);

//     const sanitizeTableName = (input) => {
//         return input
//             .toLowerCase()
//             .replace(/[^a-z0-9\s]/g, '') // Remove special characters
//             .replace(/\s+/g, '_');       // Replace spaces with underscores
//     };

//     const getTimestamp = () => {
//         const now = new Date();
//         const yy = now.getFullYear().toString().slice(-2);
//         const hh = String(now.getHours()).padStart(2, '0');
//         const mm = String(now.getMinutes()).padStart(2, '0');
//         const ss = String(now.getSeconds()).padStart(2, '0');
//         return `${yy}${hh}${mm}${ss}`;
//     };

//     const handleTableNameChange = (e) => {
//         const input = e.target.value;
//         setRawTableName(input);
//         const sanitized = sanitizeTableName(input);
//         const fullName = `tbl_${sanitized}_${getTimestamp()}`;
//         setTableName(fullName);
//     };

//     const handleColumnChange = (index, field, value) => {
//         const newColumns = [...columns];
//         if (['isPrimaryKey', 'isAutoIncrement', 'isNullable'].includes(field)) {
//             newColumns[index][field] = value.target.checked;
//         } else {
//             if (field === 'name') {
//                 const inputName = value.trim();
//                 const cleanName = inputName.toLowerCase().replace(/[^a-z0-9_]/g, '');
//                 newColumns[index][field] = cleanName.startsWith('cl_') ? cleanName : `cl_${cleanName}`;
//             } else {
//                 newColumns[index][field] = value;
//                 if (field === 'type') {
//                     const typeDef = DATA_TYPES.find(dt => dt.type === value);
//                     if (!typeDef?.needsLength) newColumns[index].length = '';
//                 }
//             }
//         }
//         setColumns(newColumns);
//     };

//     const addColumn = () => {
//         setColumns([
//             ...columns,
//             { name: '', type: '', length: '', isPrimaryKey: false, isAutoIncrement: false, isNullable: true }
//         ]);
//     };

//     const removeColumn = (index) => {
//         const newColumns = [...columns];
//         newColumns.splice(index, 1);
//         setColumns(newColumns);
//     };

//     const handleSubmit1 = (e) => {
//         e.preventDefault();
//         const user = JSON.parse(sessionStorage.getItem('user'));
//         if (!user?.id) return alert("User not found in session");

//         const formattedColumns = columns.map(col => {
//             const needsLength = DATA_TYPES.find(dt => dt.type === col.type)?.needsLength;
//             let typeDef = needsLength && col.length ? `${col.type}(${col.length})` : col.type;
//             if (!col.isNullable) typeDef += ' NOT NULL';
//             if (col.isAutoIncrement) typeDef += ' AUTO_INCREMENT';
//             if (col.isPrimaryKey) typeDef += ' PRIMARY KEY';
//             return { name: col.name, type: typeDef, description: col.description || '' };
//         });

//         const tableData = {
//             tableName,
//             columns: formattedColumns,
//             userId: user.id,
//             userName: user.email
//         };
//         fetch('https://botapi.emedha.in/pages/api/api/create-table', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify(tableData)
//         })
//             .then(res => res.text())
//             .then(msg => alert(msg))
//             .catch(err => console.error('Error:', err));
//         setRawTableName('');
//         setTableName('');
//         setColumns([
//             { name: '', type: '', length: '', description: '', isPrimaryKey: false, isAutoIncrement: false, isNullable: true }
//         ]);
//     };


//     // varma

//     const handleSubmit2 = (e) => {
//     e.preventDefault();

//     const storedUser = JSON.parse(sessionStorage.getItem('user'));

//     if (!storedUser || !storedUser.id) {
//         alert("User not found in session");
//         return;
//     }

//     // 🔥 CHECK ROLE
//     const isAdmin = storedUser.role === "admin";
//     const isMember = storedUser.role === "member";

//     // 🔥 ADMIN USES id AND MEMBER USES userId
//     const adminId = isAdmin ? storedUser.id : storedUser.userId;
//     const memberId = isMember ? storedUser.id : null;

//     // 🔥 FORMAT COLUMNS SAME AS BEFORE
//     const formattedColumns = columns.map(col => {
//         const needsLength = DATA_TYPES.find(dt => dt.type === col.type)?.needsLength;
//         let typeDef = needsLength && col.length ? `${col.type}(${col.length})` : col.type;
//         if (!col.isNullable) typeDef += ' NOT NULL';
//         if (col.isAutoIncrement) typeDef += ' AUTO_INCREMENT';
//         if (col.isPrimaryKey) typeDef += ' PRIMARY KEY';

//         return {
//             name: col.name,
//             type: typeDef,
//             description: col.description || ''
//         };
//     });

//     // 🔥 PAYLOAD (NOW ADMIN/MEMBER SAFE)
//     const payload = {
//         tableName,
//         columns: formattedColumns,
//         userId: adminId,     // Admin uses id, Member uses userId
//         userName: storedUser.email,
//         role: storedUser.role
//     };

//     // 🔥 ONLY ADD member_id IF MEMBER
//     if (isMember) {
//         payload.member_id = memberId;
//     }

//     // 🔥 POST REQUEST
//     fetch('https://botapi.emedha.in/pages/api/api/create-table', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//     })
//     .then(res => res.text())
//     .then(msg => alert(msg))
//     .catch(err => console.error('Error:', err));

//     // RESET FIELDS
//     setRawTableName('');
//     setTableName('');
//     setColumns([
//         {
//             name: '',
//             type: '',
//             length: '',
//             description: '',
//             isPrimaryKey: false,
//             isAutoIncrement: false,
//             isNullable: true
//         }
//     ]);
// };

// const handleSubmit = (e) => {
//     e.preventDefault();

//     const storedUser = JSON.parse(sessionStorage.getItem('user'));
//     if (!storedUser || !storedUser.id) {
//         alert("User not found in session");
//         return;
//     }

//     // ROLE CHECK
//     const isAdmin = storedUser.role === "admin";
//     const isMember = storedUser.role === "member";

//     // CORRECT IDs
//     const adminId = isAdmin ? storedUser.id : storedUser.userId;
//     const memberId = isMember ? storedUser.id : null;

//     // FORMAT COLUMNS
//     const formattedColumns = columns.map(col => {
//         const needsLength = DATA_TYPES.find(dt => dt.type === col.type)?.needsLength;
//         let typeDef = needsLength && col.length ? `${col.type}(${col.length})` : col.type;

//         if (!col.isNullable) typeDef += ' NOT NULL';
//         if (col.isAutoIncrement) typeDef += ' AUTO_INCREMENT';
//         if (col.isPrimaryKey) typeDef += ' PRIMARY KEY';

//         return {
//             name: col.name,
//             type: typeDef,
//             description: col.description || ''
//         };
//     });

//     // BUILD PAYLOAD
//     const payload = {
//         tableName,
//         columns: formattedColumns,
//         userId: adminId,      // Admin → id, Member → userId
//         role: storedUser.role
//     };

//     // EMAIL FIX:
//     if (isAdmin) {
//         payload.userName = storedUser.email;   // Admin email
//     } else if (isMember) {
//         payload.userName = storedUser.adminEmail;   // MUST SEND ADMIN EMAIL
//         payload.member_email = storedUser.email;      // MEMBER EMAIL SEPARATE
//         payload.member_id = memberId || 0;                // Member id
//     }

//     // SEND REQUEST
//     fetch('https://botapi.emedha.in/pages/api/api/create-table', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//     })
//     .then(res => res.text())
//     .then(msg => alert(msg))
//     .catch(err => console.error('Error:', err));

//     // RESET FIELDS
//     setRawTableName('');
//     setTableName('');
//     setColumns([
//         {
//             name: '',
//             type: '',
//             length: '',
//             description: '',
//             isPrimaryKey: false,
//             isAutoIncrement: false,
//             isNullable: true
//         }
//     ]);
// };


//     return (
//         <div className="container py-4" style={{ fontFamily: 'Segoe UI, sans-serif', fontSize: '12px' }}>
//             <div className="mb-4">
//                 <h4 className="fw-semibold text-primary">🧱 CREATE NEW TABLE</h4>
//                 <p className="text-muted">Define table name and columns to generate a dynamic database table.</p>
//             </div>

//             <form onSubmit={handleSubmit}>
//                 <div className="mb-4 p-4 shadow-sm bg-light border">
//                     <div className="mb-3">
//                         <label className="form-label fw-semibold">Table Display Name:</label>
//                         <input
//                             type="text"
//                             className="form-control"
//                             placeholder="e.g. Contacts"
//                             value={rawTableName}
//                             onChange={handleTableNameChange}
//                             required
//                             style={{ borderRadius: "0px" }}
//                         />
//                         <small className="text-muted">No special characters allowed. Spaces will be converted to underscores.</small>
//                     </div>

//                     <div className="mb-0">
//                         <label className="form-label fw-semibold">Generated Table Name:</label>
//                         <input
//                             type="text"
//                             className="form-control bg-white text-secondary"
//                             value={tableName}
//                             readOnly
//                             style={{ borderRadius: "0px" }}
//                         />
//                     </div>
//                 </div>

//                 <div className="d-flex justify-content-between align-items-center mb-3">
//                     <h6 className="mb-0 text-secondary">📑 COLUMNS</h6>
//                     <button type="button" className="btn btn-outline-primary btn-sm" onClick={addColumn}>
//                         ➕ Add Column
//                     </button>
//                 </div>

//                 <div className="row gy-4">
//                     {columns.map((col, index) => {
//                         const typeDef = DATA_TYPES.find(dt => dt.type === col.type);
//                         return (
//                             <div key={index} className="col-md-12">
//                                 <div className="card shadow-sm border-0">
//                                     <div className="card-body">
//                                         <div className="row g-3 align-items-center">
//                                             <div className="col-md-3">
//                                                 <label className="form-label">Column Name</label>
//                                                 <input
//                                                     type="text"
//                                                     className="form-control"
//                                                     placeholder="Enter column name (will be prefixed with cl_)"
//                                                     value={col.name}
//                                                     onChange={(e) => handleColumnChange(index, 'name', e.target.value)}                                               
//                                                     style={{ borderRadius: "0px" }}
//                                                 />
//                                             </div>
//                                             <div className="col-md-3">
//                                                 <label className="form-label">Data Type</label>
//                                                 <select className="form-select" value={col.type} onChange={(e) => handleColumnChange(index, 'type', e.target.value)} required style={{ borderRadius: "0px" }} >
//                                                     <option value="">Select Type</option>
//                                                     {DATA_TYPES.map((dt, i) => (
//                                                         <option key={i} value={dt.type}>{dt.type}</option>
//                                                     ))}
//                                                 </select>
//                                             </div>
//                                             {typeDef?.needsLength && (
//                                                 <div className="col-md-2">
//                                                     <label className="form-label">Length</label>
//                                                     <input
//                                                         type="number"
//                                                         className="form-control"
//                                                         placeholder="Length"
//                                                         value={col.length}
//                                                         onChange={(e) => handleColumnChange(index, 'length', e.target.value)}
//                                                         required
//                                                         style={{ borderRadius: "0px" }}
//                                                     />
//                                                 </div>
//                                             )}
//                                             <div className="col-md-4 d-flex flex-wrap align-items-center gap-3 mt-3 mt-md-0">
//                                                 <div className="form-check">
//                                                     <input
//                                                         className="form-check-input"
//                                                         type="checkbox"
//                                                         checked={col.isPrimaryKey}
//                                                         onChange={(e) => handleColumnChange(index, 'isPrimaryKey', e)}
//                                                     />
//                                                     <label className="form-check-label">Primary Key</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input
//                                                         className="form-check-input"
//                                                         type="checkbox"
//                                                         checked={col.isAutoIncrement}
//                                                         onChange={(e) => handleColumnChange(index, 'isAutoIncrement', e)}
//                                                         disabled={col.type !== 'INT'}
//                                                     />
//                                                     <label className="form-check-label">Auto Increment</label>
//                                                 </div>
//                                                 <div className="form-check">
//                                                     <input className="form-check-input" type="checkbox" checked={!col.isNullable} onChange={(e) => handleColumnChange(index, 'isNullable', e)} />
//                                                     <label className="form-check-label">Not Null</label>
//                                                 </div>
//                                                 {columns.length > 1 && index !== 0 && (
//                                                     <button type="button" className="btn btn-sm btn-outline-danger ms-auto" onClick={() => removeColumn(index)}>❌ Remove</button>
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="col-md-12">
//                                             <label className="form-label">Description</label>
//                                             <input
//                                                 type="text"
//                                                 className="form-control"
//                                                 placeholder="Purpose or description of the column"
//                                                 value={col.description}
//                                                 onChange={(e) => handleColumnChange(index, 'description', e.target.value)}
//                                                 style={{ borderRadius: "0px" }}
//                                             />
//                                         </div>

//                                     </div>
//                                 </div>

//                             </div>
//                         );
//                     })}
//                 </div>

//                 <div className="text-end mt-4">
//                     <button type="submit" className="btn btn-success px-4 py-1">✅ Create Table</button>
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default TableCreate;




import { useState, useEffect } from 'react';
import { TableProperties, Plus, Trash2 } from 'lucide-react';

const DATA_TYPES = [
    { type: 'INT', needsLength: false },
    { type: 'VARCHAR', needsLength: true },
    { type: 'CHAR', needsLength: true },
    { type: 'TEXT', needsLength: false },
    { type: 'DATE', needsLength: false },
    { type: 'DATETIME', needsLength: false },
    { type: 'FLOAT', needsLength: false },
    { type: 'DOUBLE', needsLength: false },
    { type: 'BOOLEAN', needsLength: false }
];

// Lightweight hook to handle mobile vs desktop rendering inside inline styles
function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return isMobile;
}

const TableCreate = () => {
    const isMobile = useIsMobile();
    const [tableName, setTableName] = useState('');
    const [rawTableName, setRawTableName] = useState('');
    const [columns, setColumns] = useState([
        { name: '', type: '', length: '', description: '', isPrimaryKey: false, isAutoIncrement: false, isNullable: true }
    ]);

    const sanitizeTableName = (input) => {
        return input
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '') // Remove special characters
            .replace(/\s+/g, '_');      // Replace spaces with underscores
    };

    const getTimestamp = () => {
        const now = new Date();
        const yy = now.getFullYear().toString().slice(-2);
        const hh = String(now.getHours()).padStart(2, '0');
        const mm = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');
        return `${yy}${hh}${mm}${ss}`;
    };

    const handleTableNameChange = (e) => {
        const input = e.target.value;
        setRawTableName(input);
        const sanitized = sanitizeTableName(input);
        const fullName = `tbl_${sanitized}_${getTimestamp()}`;
        setTableName(fullName);
    };

    const handleColumnChange = (index, field, value) => {
        const newColumns = [...columns];
        if (['isPrimaryKey', 'isAutoIncrement', 'isNullable'].includes(field)) {
            newColumns[index][field] = value.target.checked;
        } else {
            if (field === 'name') {
                const inputName = value.trim();
                const cleanName = inputName.toLowerCase().replace(/[^a-z0-9_]/g, '');
                newColumns[index][field] = cleanName.startsWith('cl_') ? cleanName : `cl_${cleanName}`;
            } else {
                newColumns[index][field] = value;
                if (field === 'type') {
                    const typeDef = DATA_TYPES.find(dt => dt.type === value);
                    if (!typeDef?.needsLength) newColumns[index].length = '';
                }
            }
        }
        setColumns(newColumns);
    };

    const addColumn = () => {
        setColumns([
            ...columns,
            { name: '', type: '', length: '', description: '', isPrimaryKey: false, isAutoIncrement: false, isNullable: true }
        ]);
    };

    const removeColumn = (index) => {
        const newColumns = [...columns];
        newColumns.splice(index, 1);
        setColumns(newColumns);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const storedUser = JSON.parse(sessionStorage.getItem('user'));
        if (!storedUser || !storedUser.id) {
            alert("User not found in session");
            return;
        }

        const isAdmin = storedUser.role === "admin";
        const isMember = storedUser.role === "member";

        const adminId = isAdmin ? storedUser.id : storedUser.userId;
        const memberId = isMember ? storedUser.id : null;

        // Filter out empty rows where name or type is not provided
        const validColumns = columns.filter(col => col.name && col.name !== 'cl_' && col.type);

        const formattedColumns = validColumns.map(col => {
            const needsLength = DATA_TYPES.find(dt => dt.type === col.type)?.needsLength;
            let typeDef = needsLength && col.length ? `${col.type}(${col.length})` : col.type;

            if (!col.isNullable) typeDef += ' NOT NULL';
            if (col.isAutoIncrement) typeDef += ' AUTO_INCREMENT';
            if (col.isPrimaryKey) typeDef += ' PRIMARY KEY';

            return {
                name: col.name,
                type: typeDef,
                description: col.description || ''
            };
        });

        const payload = {
            tableName,
            columns: formattedColumns,
            userId: adminId,
            role: storedUser.role
        };

        if (isAdmin) {
            payload.userName = storedUser.email;
        } else if (isMember) {
            payload.userName = storedUser.adminEmail;
            payload.member_email = storedUser.email;
            payload.member_id = memberId || 0;
        }

        fetch('https://botapi.emedha.in/pages/api/api/create-table', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
            .then(res => res.text())
            .then(msg => alert(msg))
            .catch(err => console.error('Error:', err));

        setRawTableName('');
        setTableName('');
        setColumns([
            {
                name: '',
                type: '',
                length: '',
                description: '',
                isPrimaryKey: false,
                isAutoIncrement: false,
                isNullable: true
            }
        ]);
    };

    const styles = {
        wrapper: { fontFamily: 'system-ui, -apple-system, sans-serif', maxWidth: '1200px', margin: '0 auto', backgroundColor: '#f8fafc', color: '#1e293b' },
        header: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' },
        headerIconBox: { backgroundColor: '#e0e7ff', padding: '10px', borderRadius: '8px', display: 'flex', alignItems: 'center' },
        title: { fontSize: '24px', fontWeight: 'bold', margin: 0, color: '#1e293b' },
        subtitle: { fontSize: '14px', color: '#64748b', marginTop: '4px' },
        card: { backgroundColor: '#ffffff', borderRadius: '12px', padding: '24px', boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)', marginBottom: '24px', border: '1px solid #e2e8f0' },
        cardTitle: { fontSize: '18px', fontWeight: '600', marginBottom: '16px', marginTop: 0, display: 'flex', alignItems: 'center', gap: '8px' },
        gridTwoFields: { display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap: '16px' },
        fieldGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
        label: { fontSize: '14px', fontWeight: '500', color: '#334155' },
        input: { padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '14px', width: '100%', boxSizing: 'border-box', outline: 'none', backgroundColor: '#ffffff' },
        inputDisabled: { padding: '8px 12px', borderRadius: '6px', border: '1px solid #e2e8f0', backgroundColor: '#f1f5f9', color: '#64748b', fontSize: '14px', width: '100%', boxSizing: 'border-box', cursor: 'not-allowed' },
        fieldDescription: { fontSize: '12px', color: '#64748b', marginTop: '2px' },
        desktopTableHead: { display: 'grid', gridTemplateColumns: '2.5fr 3.5fr 1fr 1.2fr 1fr 3fr 0.8fr', gap: '12px', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px', fontSize: '12px', fontWeight: '600', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em' },
        desktopTableRow: { display: 'grid', gridTemplateColumns: '2.5fr 3.5fr 1fr 1.2fr 1fr 3fr 0.8fr', gap: '12px', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #f1f5f9' },
        dataTypeContainer: { display: 'grid', gap: '8px' },
        centerFlex: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
        checkbox: { width: '16px', height: '16px', cursor: 'pointer', accentColor: '#4f46e5' },
        iconButton: (disabled) => ({
            background: 'none',
            border: 'none',
            color: disabled ? '#cbd5e1' : '#94a3b8',
            cursor: disabled ? 'not-allowed' : 'pointer',
            padding: '6px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            transition: 'all 0.2s'
        }),
        mobileCardRow: { padding: '16px', border: '1px solid #e2e8f0', borderRadius: '12px', backgroundColor: '#f8fafc', position: 'relative', display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '16px' },
        mobileTrashWrapper: { position: 'absolute', top: '12px', right: '12px' },
        mobileCheckboxGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', paddingTop: '4px' },
        mobileCheckboxLabel: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '10px 6px', border: '1px solid #e2e8f0', borderRadius: '8px', backgroundColor: '#ffffff', cursor: 'pointer', textAlign: 'center' },
        mobileCheckboxSpan: { fontSize: '10px', fontWeight: '500', color: '#475569', marginTop: '6px' },
        btnSecondary: { display: 'inline-flex', alignItems: 'center', gap: '6px', backgroundColor: '#ffffff', border: '1px solid #cbd5e1', padding: '6px 14px', borderRadius: '6px', fontSize: '13px', fontWeight: '500', color: '#334155', cursor: 'pointer', transition: 'background-color 0.2s' },
        btnPrimary: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', backgroundColor: '#4f46e5', border: 'none', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', fontWeight: '500', color: '#ffffff', cursor: 'pointer', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' },
        btnCancel: { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff', border: '1px solid #cbd5e1', padding: '10px 20px', borderRadius: '6px', fontSize: '14px', fontWeight: '500', color: '#334155', cursor: 'pointer' },
        footerActionRow: { display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '10px', marginTop: '32px', borderTop: '1px solid #e2e8f0', paddingTop: '20px' }
    };

    return (
        <div style={styles.wrapper}>
            {/* PAGE COMPONENT HEADER */}
            <div style={styles.header}>
                <div style={styles.headerIconBox}>
                    <TableProperties size={20} style={{ color: '#4f46e5' }} />
                </div>
                <div>
                    <h1 style={styles.title}>Create New Table</h1>
                    <p style={styles.subtitle}>Define table name and optional columns to generate a dynamic database table.</p>
                </div>
            </div>

            <form onSubmit={handleSubmit}>
                {/* SECTION 1: TABLE DETAILS */}
                <div style={styles.card}>
                    <h2 style={styles.cardTitle}>Table Details</h2>
                    <div style={styles.gridTwoFields}>
                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Table Display Name <span style={{ color: '#ef4444' }}>*</span></label>
                            <input
                                type="text"
                                placeholder="e.g. Contacts"
                                value={rawTableName}
                                onChange={handleTableNameChange}
                                style={styles.input}
                                required
                            />
                            <p style={styles.fieldDescription}>No special characters allowed. Spaces will be converted to underscores.</p>
                        </div>

                        <div style={styles.fieldGroup}>
                            <label style={styles.label}>Generated Table Name</label>
                            <input
                                type="text"
                                value={tableName}
                                readOnly
                                style={styles.inputDisabled}
                            />
                        </div>
                    </div>
                </div>

                {/* SECTION 2: COLUMNS SETUP */}
                <div style={styles.card}>
                    <div style={{ display: 'flex', justifyContent: 'between', alignItems: 'center', marginBottom: '20px' }}>
                        <h2 style={{ ...styles.cardTitle, marginBottom: 0 }}>📑 Columns Configuration (Optional)</h2>
                    </div>

                    {/* A. MOBILE VIEW LAYOUT */}
                    {isMobile && (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {columns.map((col, index) => {
                                const typeDef = DATA_TYPES.find(dt => dt.type === col.type);
                                const needsLength = typeDef?.needsLength;
                                return (
                                    <div key={index} style={styles.mobileCardRow}>
                                        {columns.length > 1 && (
                                            <div style={styles.mobileTrashWrapper}>
                                                <button
                                                    type="button"
                                                    onClick={() => removeColumn(index)}
                                                    style={styles.iconButton(false)}
                                                >
                                                    <Trash2 size={16} style={{ color: '#ef4444' }} />
                                                </button>
                                            </div>
                                        )}

                                        <div style={styles.fieldGroup}>
                                            <label style={styles.label}>Column Name</label>
                                            <input
                                                type="text"
                                                placeholder="Enter column name (will be prefixed with cl_)"
                                                value={col.name}
                                                onChange={(e) => handleColumnChange(index, 'name', e.target.value)}
                                                style={styles.input}
                                            />
                                        </div>

                                        <div style={{ display: 'grid', gridTemplateColumns: needsLength ? '7fr 5fr' : '1fr', gap: '8px' }}>
                                            <div style={styles.fieldGroup}>
                                                <label style={styles.label}>Data Type</label>
                                                <select
                                                    value={col.type}
                                                    onChange={(e) => handleColumnChange(index, 'type', e.target.value)}
                                                    style={styles.input}
                                                >
                                                    <option value="">Select Type</option>
                                                    {DATA_TYPES.map((dt, i) => (
                                                        <option key={i} value={dt.type}>{dt.type}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {needsLength && (
                                                <div style={styles.fieldGroup}>
                                                    <label style={styles.label}>Length</label>
                                                    <input
                                                        type="number"
                                                        placeholder="Length"
                                                        value={col.length}
                                                        onChange={(e) => handleColumnChange(index, 'length', e.target.value)}
                                                        style={styles.input}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div style={styles.mobileCheckboxGrid}>
                                            <label style={styles.mobileCheckboxLabel}>
                                                <input
                                                    type="checkbox"
                                                    checked={col.isPrimaryKey}
                                                    onChange={(e) => handleColumnChange(index, 'isPrimaryKey', e)}
                                                    style={styles.checkbox}
                                                />
                                                <span style={styles.mobileCheckboxSpan}>Primary Key</span>
                                            </label>
                                            <label style={styles.mobileCheckboxLabel}>
                                                <input
                                                    type="checkbox"
                                                    checked={col.isAutoIncrement}
                                                    onChange={(e) => handleColumnChange(index, 'isAutoIncrement', e)}
                                                    disabled={col.type !== 'INT'}
                                                    style={styles.checkbox}
                                                />
                                                <span style={styles.mobileCheckboxSpan}>Auto Inc</span>
                                            </label>
                                            <label style={styles.mobileCheckboxLabel}>
                                                <input
                                                    type="checkbox"
                                                    checked={!col.isNullable}
                                                    onChange={(e) => handleColumnChange(index, 'isNullable', e)}
                                                    style={styles.checkbox}
                                                />
                                                <span style={styles.mobileCheckboxSpan}>Not Null</span>
                                            </label>
                                        </div>

                                        <div style={styles.fieldGroup}>
                                            <label style={styles.label}>Description</label>
                                            <input
                                                type="text"
                                                placeholder="Purpose or description of the column"
                                                value={col.description}
                                                onChange={(e) => handleColumnChange(index, 'description', e.target.value)}
                                                style={styles.input}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* B. DESKTOP VIEW LAYOUT */}
                    {!isMobile && (
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={styles.desktopTableHead}>
                                <div>Column Name</div>
                                <div>Data Type / Length</div>
                                <div style={{ textAlign: 'center' }}>P. Key</div>
                                <div style={{ textAlign: 'center' }}>Auto Inc</div>
                                <div style={{ textAlign: 'center' }}>Not Null</div>
                                <div>Description</div>
                                <div style={{ textAlign: 'center' }}>Actions</div>
                            </div>

                            {columns.map((col, index) => {
                                const typeDef = DATA_TYPES.find(dt => dt.type === col.type);
                                const needsLength = typeDef?.needsLength;
                                return (
                                    <div key={index} style={styles.desktopTableRow}>
                                        <div>
                                            <input
                                                type="text"
                                                placeholder="e.g. id"
                                                value={col.name}
                                                onChange={(e) => handleColumnChange(index, 'name', e.target.value)}
                                                style={styles.input}
                                            />
                                        </div>

                                        <div style={{ ...styles.dataTypeContainer, gridTemplateColumns: needsLength ? '7fr 5fr' : '1fr' }}>
                                            <div>
                                                <select
                                                    value={col.type}
                                                    onChange={(e) => handleColumnChange(index, 'type', e.target.value)}
                                                    style={styles.input}
                                                >
                                                    <option value="">Select Type</option>
                                                    {DATA_TYPES.map((dt, i) => (
                                                        <option key={i} value={dt.type}>{dt.type}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            {needsLength && (
                                                <div>
                                                    <input
                                                        type="number"
                                                        placeholder="Length"
                                                        value={col.length}
                                                        onChange={(e) => handleColumnChange(index, 'length', e.target.value)}
                                                        style={styles.input}
                                                    />
                                                </div>
                                            )}
                                        </div>

                                        <div style={styles.centerFlex}>
                                            <input
                                                type="checkbox"
                                                checked={col.isPrimaryKey}
                                                onChange={(e) => handleColumnChange(index, 'isPrimaryKey', e)}
                                                style={styles.checkbox}
                                            />
                                        </div>

                                        <div style={styles.centerFlex}>
                                            <input
                                                type="checkbox"
                                                checked={col.isAutoIncrement}
                                                onChange={(e) => handleColumnChange(index, 'isAutoIncrement', e)}
                                                disabled={col.type !== 'INT'}
                                                style={styles.checkbox}
                                            />
                                        </div>

                                        <div style={styles.centerFlex}>
                                            <input
                                                type="checkbox"
                                                checked={!col.isNullable}
                                                onChange={(e) => handleColumnChange(index, 'isNullable', e)}
                                                style={styles.checkbox}
                                            />
                                        </div>

                                        <div>
                                            <input
                                                type="text"
                                                placeholder="Column context description..."
                                                value={col.description}
                                                onChange={(e) => handleColumnChange(index, 'description', e.target.value)}
                                                style={styles.input}
                                            />
                                        </div>

                                        <div style={styles.centerFlex}>
                                            <button
                                                type="button"
                                                onClick={() => removeColumn(index)}
                                                style={styles.iconButton(columns.length === 1)}
                                                disabled={columns.length === 1}
                                            >
                                                <Trash2 size={16} style={columns.length > 1 ? { color: '#64748b' } : {}} />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}

                    {/* Dynamic Action Trigger Row */}
                    <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'flex-start' }}>
                        <button type="button" onClick={addColumn} style={styles.btnSecondary}>
                            <Plus size={14} /> Add Column
                        </button>
                    </div>

                    {/* Submission Layout Footprint */}
                    <div style={styles.footerActionRow}>
                        <button type="submit" style={styles.btnPrimary}>
                            <TableProperties size={14} /> Generate Table
                        </button>
                        <button
                            type="button"
                            style={styles.btnCancel}
                            onClick={() => {
                                setRawTableName('');
                                setTableName('');
                                setColumns([{ name: '', type: '', length: '', description: '', isPrimaryKey: false, isAutoIncrement: false, isNullable: true }]);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default TableCreate;